/* jokers-pdp.js */

/* ── Badge update functions ────────────────────────────────────── */
function jokers_updateInventory(v) {
  var el = document.getElementById('jokers-low-stock');
  if (!el || !v) return;
  el.className = 'jokers-inv';
  if (!v.available) {
    el.classList.add('jokers-inv--out');
    el.innerHTML = '<span class="jokers-inv__dot"></span>Out of stock';
  } else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 10) {
    el.classList.add('jokers-inv--low');
    el.innerHTML = '<span class="jokers-inv__dot"></span>Hurry \u2014 only ' + v.inventory_quantity + ' left in stock!';
  } else {
    el.classList.add('jokers-inv--in');
    el.innerHTML = '<span class="jokers-inv__dot"></span>In stock';
  }
}

function jokers_updateSaveBadge(v) {
  var b = document.getElementById('jokers-save-badge');
  if (!b || !v) return;
  if (v.compare_at_price && v.compare_at_price > v.price) {
    b.textContent = 'Save $' + ((v.compare_at_price - v.price) / 100).toFixed(2);
    b.style.display = '';
  } else {
    b.style.display = 'none';
  }
}

function jokers_updateAfterpay(v) {
  var ap = document.getElementById('jokers-afterpay');
  var amt = document.getElementById('jokers-afterpay-amount');
  if (!ap || !amt || !v) return;
  if (v.price >= 3500) {
    ap.style.display = '';
    amt.textContent = '$' + (v.price / 400).toFixed(2);
  } else {
    ap.style.display = 'none';
  }
}

/* ── Listen to Shopify variant:change ─────────────────────────── */
document.addEventListener('variant:change', function(e) {
  var v = e.detail && (e.detail.variant || e.detail);
  if (v && v.id) {
    jokers_updateInventory(v);
    jokers_updateSaveBadge(v);
    jokers_updateAfterpay(v);
  }
});
